import axios from "../axios-auth";
import orginal_axios from "axios";

export const supplierService = {
  getSupplierList,
  saveSupplier,
  saveSupplierProduct,
  getSupplierDetail,
  getSupplierProduct,
  saveFiles,
  downloadFile,
  getAllSupplier,
  getSuppliersByProductId,
  getSupplierExcelTemplate,
  getSupplierExcelExport,
  importSupplier
};

function getSupplierList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };
  
  if (searchParams.companyName) {
    params["companyName"] = searchParams.companyName;
  }
  if (searchParams.creditLevelIds) {
    params["creditLevelIds"] = searchParams.creditLevelIds.join();
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.ids) {
    params["ids"] = searchParams.ids.join();
  }

  return axios.get("/auth/suppliers", { params });
}

function saveSupplier(supplier) {
  if (!supplier.id) {
    return axios.post("/auth/supplier", supplier);
  } else {
    return axios.put("/auth/supplier", supplier);
  }
}

function saveSupplierProduct(supplierProduct) {
  if (!supplierProduct.id) {
    return axios.post("/auth/supplier-product", supplierProduct);
  } else {
    return axios.put("/auth/supplier-product", supplierProduct);
  }
}

function getSupplierDetail(id) {
  return axios.get("/auth/supplier/" + id);
}

function getSupplierProduct(searchParams) {
  let params = {};
  if (searchParams.supplierId) {
    params["supplierId"] = searchParams.supplierId;
  }
  if (searchParams.productId) {
    params["productId"] = searchParams.productId;
  }
  if (searchParams.productUnitId) {
    params["productUnitId"] = searchParams.productUnitId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/supplier-product", { params });
}

function saveFiles(files, id) {
  return axios.post('/auth/supplier/files/' + id,
    files,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function downloadFile(id) {
  return axios.get("/auth/supplier/downloadFile/" + id, { responseType: "blob" });
}

function getAllSupplier() {
  return axios.get("/auth/all-supplier");
}

function getSuppliersByProductId(productId) {
  return axios.get("/auth/suppliers-by-product-id/" + productId);
}

function getSupplierExcelExport(searchParams) {
  let params = {};

 if (searchParams.companyName) {
    params["companyName"] = searchParams.companyName;
  }
  if (searchParams.creditLevelIds) {
    params["creditLevelIds"] = searchParams.creditLevelIds.join();
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.ids) {
    params["ids"] = searchParams.ids.join();
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/supplier-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getSupplierExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/supplier-import-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function importSupplier(file) {
  return axios.post('/auth/supplier-import',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}